<template>
  <div>
    <h2>Goals <span v-if="loaded" class="results">({{ displayedGoals.length }})</span></h2>
    <subject-filter
      :subjects="filterOptions"
      :resource="resourceType"
      :page="pageType"/>
    <br>
    <router-link
      v-if="loaded && goals.length === 0"
      class="browse-link"
      :to="{name: 'BrowseGoalsPage'}">Find some goals</router-link>
    <div class="row">
      <div class="col-sm-6">
        <template
          v-for="(goal, index) in displayedGoals">
          <goal-display-card
            :key="goal.uuid"
            v-if="index % 2 === 0"
            :goal="goal.content_body"
            :created="goal.created_at" />
        </template>
      </div>
      <div class="col-sm-6">
        <template
          v-for="(goal, index) in displayedGoals">
          <goal-display-card
            :key="goal.uuid"
            v-if="index % 2 === 1"
            :goal="goal.content_body"
            :created="goal.created_at" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import GoalDisplayCard from '@/components/favorites/GoalDisplayCard'
import SubjectFilter from '@/components/favorites/SubjectFilter'
import { mapState } from 'vuex'

export default {
  name: 'GoalFavorites',
  components: {
    GoalDisplayCard,
    SubjectFilter
  },
  props: {
    goals: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      resourceType: 'goals',
      pageType: 'favorites'
    }
  },
  computed: {
    ...mapState('favorites', ['loaded', 'filters']),
    displayedGoals() {
      return (
        this.filterGoalsBySubject(this.goals, this.filters.goals).sort((g1, g2) => {
          if (g1.created_at < g2.created_at) {
            return 1
          }
          if (g1.created_at > g2.created_at) {
            return -1
          }
          return 0
        }) || []
      )
    },
    filterOptions() {
      var options = ['All Subjects']
      this.goals &&
        this.goals.forEach(goal => {
          const goalSubjectsToAdd = this.subjectsForGoal(goal).filter(s => !options.includes(s))
          if (goalSubjectsToAdd.length > 0) {
            options = options.concat(goalSubjectsToAdd)
          }
        })
      return options
    }
  },
  methods: {
    filterGoalsBySubject(goals, subject) {
      if (subject === 'All Subjects') {
        // always return a new array to avoid mutability operations (e.g. sort)
        return [].concat(goals)
      }
      return goals.filter(goal => {
        return this.subjectsForGoal(goal).includes(subject)
      })
    },
    subjectsForGoal(goal) {
      let goalSubjects = [goal.content_body.subject]
      if (Array.isArray(goal.content_body.subject_alignments) && goal.content_body.subject_alignments.length > 0) {
        goalSubjects = goal.content_body.subject_alignments.map(sa => sa.subject)
      }
      return goalSubjects
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.results {
  color: @blue;
  font-weight: 300;
}
.browse-link {
  font-size: 28px;
}
</style>
